import { NgModule } from '@angular/core';
import { AuthModule } from '@features/auth/auth.module';
import { StateModule } from '@features/state/state.module';
import { AnalyticsService } from './analytics.service';
import { DataLayerService } from './data-layer.service';
import { DownloadAnalyticsService } from './download-analytics.service';
import { NavigationAnalyticsService } from './navigation-analytics.service';
import { PageViewTrackerComponent } from './page-view-tracker/page-view-tracker.component';
import { ShoppingAnalyticsService } from './shopping-analytics.service';

@NgModule({
  imports: [StateModule, AuthModule],
  declarations: [PageViewTrackerComponent],
  exports: [PageViewTrackerComponent],
  providers: [
    AnalyticsService,
    DataLayerService,
    DownloadAnalyticsService,
    NavigationAnalyticsService,
    ShoppingAnalyticsService,
  ],
})
export class TagManagerModule {}
